<template>
    <v-simple-table
        v-if="
            !isInternationalShipping && !cartContainsOnlyShippingChargedProducts
        "
        dense
        class="totals-table--bordered"
    >
        <thead>
            <tr>
                <th class="totals-th--bordered">
                    <span><TranslatableStringComponent :tstring="{string: 'shippingMethod'}" /></span>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td class="totals-td--bordered">
                    <div v-if="selectedCarrierMethod === 'default'">
                        <v-radio-group
                            v-model="selectedShippingMethod"
                            class="pb-0"
                        >
                            <v-radio value="ground" color="primary" :disabled="shippingMethodException">
                                <template v-slot:label>
                                    <div>
                                        <TranslatableStringComponent :tstring="{string: 'ground'}" />
                                        {{ fetchGroundShippingCost }}
                                        <i
                                            v-if="isFreeGroundShippingApplied"
                                            class="caption"
                                            >
                                            <TranslatableStringComponent :tstring="{string: 'freeGroundShipping'}" />
                                        </i>
                                    </div>
                                </template>
                            </v-radio>
                            <v-radio
                                :label="`${localize('air2day')} ${
                                    fetchShippingOptions.air2day
                                        ? `(${dollars(
                                              fetchShippingOptions.air2day,
                                              0
                                          )})`
                                        : `${localize('tbdParentheses')}`
                                }`"
                                value="air2day"
                                color="primary"
                            ></v-radio>
                            <v-radio
                                :label="`${localize('air1day')} ${
                                    fetchShippingOptions.air1day
                                        ? `(${dollars(
                                              fetchShippingOptions.air1day,
                                              0
                                          )})`
                                        : `${localize('tbdParentheses')}`
                                }`"
                                value="air1day"
                                color="primary"
                            ></v-radio>
                        </v-radio-group>
                        <!-- <p
                            v-if="shippingExemptionFound"
                            style="font-size: 12px"
                        >
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />{{ localize('shippingExemptionNote') }}
                        </p> -->
                        <p
                            v-if="shippingChargedProducts.length > 0"
                            style="font-size: 12px"
                        >
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <TranslatableStringComponent :tstring="{string: 'normalShippingProducts'}" />
                        </p>
                        <p v-if="isShippingTBD" style="font-size: 12px">
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <TranslatableStringComponent :tstring="{string: 'shippingTBDNote'}" />
                        </p>
                        <p
                            v-if="sameDayShippingExemptionFound"
                            style="font-size: 12px"
                        >
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <TranslatableStringComponent :tstring="{string: 'sameDayShippingExemptionNote'}" />
                        </p>
                    </div>
                    <div v-if="selectedCarrierMethod !== 'default'">
                        <v-radio-group
                            v-model="selectedShippingMethod"
                            class="pb-0"
                        >
                            <v-radio
                                :label="`${localize('ground')} (TBD)`"
                                value="ground"
                                color="primary"
                                :disabled="shippingMethodException"
                            ></v-radio>
                            <v-radio
                                :label="`${localize('air2day')}(TBD)`"
                                value="air2day"
                                color="primary"
                            ></v-radio>
                            <v-radio
                                :label="`${localize('air1day')} (TBD)`"
                                value="air1day"
                                color="primary"
                            ></v-radio>
                        </v-radio-group>
                        <p style="font-size: 12px">
                            <fa
                                :icon="['fal', 'info-circle']"
                                v-bind="attrs"
                                class="fa-lg mr-2"
                                style="color: #0063a6"
                            />
                            <TranslatableStringComponent :tstring="{string: 'shippingTBDNote'}" />
                        </p>
                    </div>
                </td>
            </tr>
        </tbody>
    </v-simple-table>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'
export default {
    name: 'ShippingMethodSection',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return { attrs: null }
    },
    computed: {
        ...mapGetters({
            isInternationalShipping: 'checkout/isInternationalShipping',
            fetchShippingOptions: 'cart/fetchShippingOptions',
            shippingExemptionFound: 'cart/shippingExemptionFound',
            isShippingTBD: 'cart/isShippingTBD',
            discountValue: 'coupon/discountValue',
            freeGroundShippingThreshold: 'auth/freeGroundShippingThreshold',
            isDistributor: 'auth/isDistributor',
            subtotal: 'cart/fetchCartSubtotal',
            sameDayShippingExemptionFound: 'cart/sameDayShippingExemptionFound',
            cartContainsOnlyShippingChargedProducts:
                'cart/cartContainsOnlyShippingChargedProducts',
            shippingChargedProducts: 'cart/shippingChargedProducts',
            shippingMethodException: 'checkout/shippingMethodException',
        }),
        ...mapState('cart', ['selectedCarrierMethod']),
        ...mapState('coupon', ['couponObj']),
        selectedShippingMethod: {
            get() {
                return this.$store.state.cart.selectedShippingMethod
            },
            set(v) {
                this.$store.dispatch('cart/updateShipping', v)
            },
        },
        fetchGroundShippingCost() {
            if (this.discountValue && this.couponObj.freeShipping) {
                return `(FREE)` // `(${this.dollars(0, 0)}) `
            } else if (this.isDistributor) {
                if (
                    this.freeGroundShippingThreshold &&
                    this.freeGroundShippingThreshold !== '0' &&
                    this.subtotal > parseInt(this.freeGroundShippingThreshold)
                ) {
                    return `(FREE)` // `(${this.dollars(0, 0)}) `
                } else {
                    return this.fetchShippingOptions.groundDist === 0
                        ? `(FREE)`
                        : `(${this.dollars(
                              this.fetchShippingOptions.groundDist,
                              0
                          )})`
                }
            } else {
                return this.fetchShippingOptions.ground === 0
                    ? `(FREE)`
                    : `(${this.dollars(this.fetchShippingOptions.ground, 0)})`
            }
        },
        isFreeGroundShippingApplied() {
            if (this.discountValue && this.couponObj.freeShipping) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style></style>
